import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import PublicLayout from "web/components/PublicLayout";
import styled from "styled-components";
import LoginForm from "./LoginForm";
import Img1 from "web/assets/images/signup1.png";
import Img2 from "web/assets/images/signup2.png";
import Img3 from "web/assets/images/signup3.svg";
import { Col, Row } from "reactstrap";
import LandingFooter from "../LandingFooter";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const SignUp = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    history.push("/contact-us");
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // let token = localStorage.getItem('token')
    // let isAdminOrUserAccount = localStorage.getItem('accountType')
    // if (isAdminOrUserAccount && token) {
    //   if (isAdminOrUserAccount === 'Admin') history.push('/admin')
    //   else history.push('/dashboard')
    // } else {
    //   dispatch(logoutAdmin())
    //   dispatch(logoutClearRedux())
    //   localStorage.clear()
    //   sessionStorage.clear()
    // }
  }, [])

  return (
    <>
      <Helmet title="Contact Us for Pallet Supply Solutions | PalletTrader">
        <meta
          name="description"
          content="Contact us for pallet solutions with a personalized demo. Buy or sell pallets efficiently. Join us now to optimize your pallet operations."
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/contact-us" />
      </Helmet>
      <PublicLayout transparentHeader={true}>
        <SectionContainer>
          {/* <Col md="4">
              <section className="left-section text-center font-semibold">
                <div className="">
                  <img
                    className="mx-auto "
                    width="60%"
                    height="auto"
                    src={Img1}
                    alt="PalletTrader curved text logo"
                  />
                </div>
                <h1 className="uppercase mx-auto mt-6 leading-10 max-w-sm mt-4">
                  Contact us to Learn <br /> More or Schedule a Personalized
                  Demo
                </h1>

                <img
                  className="mx-auto my-5 max-w-md w-full"
                  src={Img2}
                  alt="A photo of a wooden pallet"
                  loading="lazy"
                  width="500"
                  height="109"
                  style={{ maxWidth: "100%" }}
                />

                <div>
                  <img
                    className="mx-auto mt-4 max-w-sm w-full "
                    src={Img3}
                    alt="PalletTrader logo"
                    loading="lazy"
                    width="380"
                    height="66"
                    style={{ maxWidth: "100%" }}
                  />
                </div>
              </section>
            </Col> */}
          <section className="wrp">
            <section className="contact-header">
              <h1>Contact Us.</h1>
              <h4>We Want to Hear From You.</h4>
            </section>
            <p style={{ margin: '20px 0px -10px 32px', fontFamily: 'latomedium' }}>Fill out the below form, or feel free to call us directly at <a href="tel:+1-877-777-7495">1-877-777-7495</a> or email at <a style={{ 'color': 'blue' }} href="mailto:support@pallettrader.com">support@pallettrader.com</a>.</p>
            <section className="right-section font-semibold">
              <div className="form-section">
                <LoginForm />
              </div>
            </section>
          </section>
        </SectionContainer>
        <LandingFooter isBackgroundWhite={true} />
      </PublicLayout>
    </>
  );
};

export default SignUp;

const SectionContainer = styled.div`
  /* max-width: 1210px; */
  max-width: 1440px;
  margin: 0 auto;
  background-color: #f5f6f6;
  /* padding: 2.8vw 0; */
  padding: 1vw 0;
  .wrp {
    max-width: 1210px;
    margin: 0 auto;
    width: 100%;
    background-color: #ffffff;
  }
  .contact-header {
    background-color: #e3f1fb;
    color: #233354;
    text-align: center;
    /* padding: 2vw 16px; */
    padding: 0.6vw 16px;
    h1 {
      color: #233354;
      max-width: 100%;
    }
  }
  .left-section,
  .right-section {
    padding: 2rem 2rem;
  }
  .form-section {
    margin: 0 auto;

    .col-md-6 {
      /* margin-bottom: 5px; */
      margin-bottom: 0.8vw;
    }
  }
  h1 {
    text-transform: unset;
    font-size: 32px;
    font-weight: 600;
    line-height: 45px;
    max-width: 480px;
    color: #61b01f;
    letter-spacing: 1px;
  }
  button.btn.btn-primary {
    background: #15578a;
    border: none;
    width: 150px;
  }
  .left-heading {
    font-size: 20px;
    font-family: "latosemibold";
  }
  .rich-text {
    font-family: "latosemibold";
  }
`;
